import { Component, OnDestroy, OnInit } from '@angular/core';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginService } from './login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  email = '';
  password = '';
  token = 'not defined';
  faSign = faSignInAlt;

  private destroy$ = new Subject<void>();

  constructor(private loginService: LoginService) { }

  ngOnInit() {
    // UI-only: clear the form when the user logs out. Auth state and
    // NgRx dispatches are handled by `LoginService` itself, so this
    // component never has to know about the store.
    this.loginService.isLoggedIn$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(loggedIn => {
      if (!loggedIn) {
        this.email = '';
        this.password = '';
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSubmit() {
    this.loginService.login(this.email, this.password);
  }

}
